export default {
  initialize: 'initialize',
  onLenderTypeSelection: 'onLenderTypeSelection',
  onLenderSelection: 'onLenderSelection',
  onTransactionTimeOut: 'onTransactionTimeOut',
};



// WEBPACK FOOTER //
// ./components/transaction/src/actions/onPaymentInit/actionType.js